import clsx from 'clsx'
import { flagColor, flagLabel } from '../labels'

interface Props {
  /** Raw client-flag value (цвет: white / red / … или ALL / NEW / RETURNING). */
  flag: string
  className?: string
}

const NEUTRAL_DOT = '#a1a5b7' // gray-500: неизвестный флаг

/**
 * CHC-877: клиентский флаг (externalUserFlag) как отдельный наглядный чип.
 * CHC-892: реальные значения флага — цвета. Перед русской подписью рисуем
 * маленький цветной дот (цвет = цвет флага), а сам бейдж оставляем ненавязчивым
 * (badge-light). Белый дот получает тонкую рамку, чтобы быть видимым на светлом
 * фоне; неизвестный флаг → нейтральный серый дот.
 */
export const FlagChip = ({ flag, className }: Props) => {
  const color = flagColor(flag)
  const dotColor = color ?? NEUTRAL_DOT
  const isWhite = color === '#ffffff'

  return (
    <span
      className={clsx(
        'badge badge-light d-inline-flex align-items-center',
        className
      )}
      title='Клиентский флаг'
    >
      <span
        className='d-inline-block rounded-circle me-2 flex-shrink-0'
        style={{
          width: 9,
          height: 9,
          backgroundColor: dotColor,
          border: isWhite ? '1px solid #d9d9d9' : undefined,
        }}
      />
      {flagLabel(flag)}
    </span>
  )
}
